import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { withStyles } from '@material-ui/core/styles';
const styles = theme => ({
    note: {
        border: 0,
        background: theme.palette.background.note,
        borderRadius: theme.spacing(1),
        outline: 'none',
        padding: theme.spacing(1),
        fontFamily: 'Open Sans',
        fontSize: theme.spacing(2)

    },
    phone: {
        paddingLeft: '12px !important',
        width: '100% !important',
        height: '64px !important',
        backgroundColor: theme.palette.background.default + ' !important',
        border: '1px solid transparent !important',
        boxShadow: 'none !important'

    },
    notchedOutline: {
        borderWidth: "1px",
        borderColor: "yellow !important"
    },
    dropDown: {
        display: 'none !important'
    }

})



const PhoneInputComp = ({ classes, value, defaultValue, ticketId, type, posting, teeTimeIndex, handlePhoneChange }) => {
    const [, setPhone] = useState();
    const phoneInputChange = (phone) => {
        setPhone(phone);
        updatePhoneEditInProps(phone);
    }
    const updatePhoneEditInProps = (phone) => {
        handlePhoneChange(phone)
    }
    return <div>
        <PhoneInput
            inputClass={classes.phone}
            buttonClass={classes.dropDown}
            disableDropdown={true}
            disableCountryCode={true}
            onlyCountries={["us"]}
            placeholder={""}
            country={'us'}
            value={value}
            onChange={phone => phoneInputChange(phone)}
        />

    </div>
}



export default withStyles(styles)(PhoneInputComp)